import type { NoteType, UUID } from "@/core/types";

import { CreateAcaAddendum } from "./(advanced-care)/CreateAcaAddendum";
import { CreateGeneralAddendum } from "./(general)/CreateGeneralAddendum";

type CreateAddendumProps = {
  credentials: string | undefined;
  noteId: UUID;
  noteType: NoteType | null;
  onCancel: () => void;
  onSuccess: () => void;
  patientId: UUID;
  signature: string | undefined;
};

// Only file in the feature allowed to know both (general) and (acaa) exist —
// picks the variant by note type so callers never branch on it themselves.
export function CreateAddendum({ noteType, ...props }: CreateAddendumProps) {
  return noteType === "Advanced Care Activity" ? (
    <CreateAcaAddendum {...props} />
  ) : (
    <CreateGeneralAddendum {...props} />
  );
}
